import { PaginationType } from "../interfaces/pagination/pagination-type"

export const STATUS = [
    'Enabled',
    'Disabled'
]

export const TWO_FACTOR_AUTHENTICATION = [
    'Enabled',
    'Disabled'
]

export const LOGIN_IP = [
    'Enabled',
    'Disabled'
]

export const SMTP_STATUS = [
    { id: 'true', value: 'Enabled' },
    { id: 'false', value: 'Disabled' },
]

export const STORE_LIST = [
    { name: 'Crizac', value: '1' },
    { name: 'Ucol', value: '2' },
    { name: 'GASPL', value: '3' },
]

export const INPUT_TYPE = [
    { id: 'Radio Button', value: 'Radio Button' },
    { id: 'Text', value: 'Text' },
]

export const RISK_TYPE = [
    { id: 1, value: '1' },
    { id: 2, value: '2' },
    { id: 3, value: '3' },
    { id: 4, value: '4' },
]

export const PREPARED_STATUS = [
    { id: 1, value: '1', name: 'Prepared' },
    { id: 2, value: '2', name: 'Not Prepared' },
    { id: 3, value: '3', name: 'Need To Prepared' },
    { id: 4, value: '4', name: 'NA' },
]

export const CATEGORY_TYPE = [
    { id: 1, value: 'Common' },
    { id: 2, value: 'Complusory Questions' },
    { id: 3, value: 'Doubtful' },
    { id: 4, value: 'Decision' },
]

export const LINK_STATUS = [
    { _id: true, value: 'Enabled' },
    { _id: false, value: 'Disabled' },
]

export const AGENT_COMMISSIOM = [
    { id: true, value: 'Enabled' },
    { id: false, value: 'Disabled' },
]

export const ASSIGN_STATUS = [
    { id: 1, value: 'Assign' },
    { id: 2, value: 'Re-Assign' },
]

export const INTERVIEW_TYPE_STATUS = [
    { id: 1, value: 'Final' },
    { id: 2, value: 'High Commission Credibility' },
    { id: 3, value: 'Mock' },
    { id: 4, value: 'Pre Application Credibility' },
]

export const INTERVIEW_MODE_STATUS = [
    { id: 1, value: 'Zoom' },
    { id: 2, value: 'Skype' },
    { id: 3, value: 'Click To Call' },
    { id: 4, value: 'Other' },
]

export const APP_STATUS = [
    { id: true, value: 'Application Processed' },
    { id: false, value: 'Application Not Processed' },
]

export const TIER_STATUS = [
    { id: 1, value: '1' },
    { id: 2, value: '2' },
    { id: 3, value: '3' },
    { id: 4, value: '4' },
]

export const CAT_STATUS = [
    { id: 5, value: 'Case Closed' },
    { id: 7, value: 'Application Processed' },
    { id: 19, value: 'Application Not Processed' },
    { id: 101, value: ' Application Ok for Processing ' }
]

export const CPT_STATUS = [
    { id: 5, value: 'Case Closed' },
    { id: 7, value: 'Application Processed' },
    { id: 19, value: 'Application Not Processed' },
    { id: 101, value: ' Application Ok for Processing ' }
]

export const SMTP_TYPE = [
    { id: 'master', value: 'Master' },
    { id: 'other', value: 'Other' },
]

export const SEATS = [
    '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'
]

// export const COA_List = ['AOA', 'Case Owner', 'ORIGINAL', 'UCAS'];
export const COA_List = [
    { name: 'AOA', value: 'AOA' },
    { name: 'COA', value: 'COA' },
    { name: 'ORIGINAL', value: 'ORIGINAL' },
    { name: 'UCAS', value: 'UCAS' }
];

export const interview_Status = [
    { name: 'Pass', value: 'Pass' },
    { name: 'Fail', value: 'Fail' },
    { name: 'Final Schedule', value: 'Final Schedule' },
    { name: 'Outcome Pending', value: 'Outcome Pending' },
    { name: 'Resit Requested', value: 'Resit Requested' },
    { name: 'Pending / Not Recorded', value: 'Pending / Not Recorded' },
    { name: 'Not Required', value: 'Not Required' },
]
export const Married = [
    { id: 'Married', value: 'Yes' },
    { id: 'Unmarried', value: 'No' },
]

export const InterviewType = [
    'Pre Application Credibility',
    'High Application Credibility',
    'Mock',
    'Final'
]

export const InterviewMode = [
    'ZegoCloud',
    'Zoom',
    'Skype',
    'Click to call',
    'Other',
    'aiBot',
    'aiBotPartner',
]

export const InterviewModeMapping = {
    zoom: 'Zoom',
    skype: 'Skype',
    call: 'Click to call',
    other: 'Other',
    aiBot: 'AI-Bot',
    aiBotPartner: 'AI-Bot With Participant',
}

export const PaginationConfig: PaginationType = {
    size: 10,
    total: 0,
    skip: 0,
    limit: 10
}

export const DgreeType = [
    { name: 'Degree', id: 1 },
    { name: 'Others', id: 2 },
    { name: 'PG', id: 3 },
    { name: 'UG', id: 4 },
    { name: 'Tenth', id: 5 },
    { name: 'Twelve', id: 6 }
]

export const FilterType = {
    reset: 'reset',
    apply: 'apply'
}

export const DocRestrictionsExtensions = [
    '.jpg',
    '.jpeg',
    '.png',
    '.docx',
    '.doc',
    '.txt',
    '.pdf',
    '.zip',
    '.csv',
    '.xlx',
    '.xls',
    '.xlsx',
    '.mp3',
    '.pptx',
    '.wav',
    '.mp4',
    '.csb',

]

export const NoOfQualYears = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

export const SearchEntity = {
    debounce_time: 1000,
    clear_search_input: false
}
export const agentBadge =[
    { id: 'noBadge', name: 'Not Added' },
    {id: 'platinum', name: 'Platinum'},
    { id: 'gold', name: 'Gold' },
    { id: 'silver', name: 'Silver' },
    { id: 'bronze', name: 'Bronze' },
    { id: 'copper', name: 'Copper' },
    { id: 'iron', name: 'Iron' },
    { id: 'steel', name: 'Steel' }
]

export const ApplicationType = [
    { id: 'Crizac Application', name: 'Crizac Application' },
    { id: 'Other Application', name: 'Other Application' }
]

export const EmailActivityType = {
    management: { id: 1, value: 'management' },
    junk: { id: 2, value: 'junk' },
    urm: { id: 3, value: 'urm' },
    important: { id: 11, value: 'important' },
    done: { id: 12, value: 'done' },
}

export const PaginationLimit = {
    university: 50,
    agent: 50,
    user: 50,
    board: 50,
}

export const InputType = [
    { id: 'text', value: 'Text' },
    { id: 'dropdown', value: 'Dropdown' },
    { id: 'numeric', value: 'Numeric' }
]

export const OptionInputTypes = {
    text: 'text',
    dropdown: 'dropdown',
    numeric: 'numeric'
}

export const AnswerTypeForForms = [
    {
        text: 'Text',
        value: 'input'
    },
    {
        text: 'Radio',
        value: 'radio'
    },
    {
        text: 'Long Text',
        value: 'textarea'
    },
    {
        text: 'Options',
        value: 'options'
    },
]

export const optionsTemplateConst = [
    {
        text: 'Degree Menu',
        id: "1722249482",
        key_value_columns: ['Option Name', 'Option Value', 'Sort Order', 'Source Country', 'Education Level', 'Status']
    },
    {
        text: 'Overall Grade',
        id: "1722263592",
        key_value_columns: ['Option Name', 'Option Value', 'Sort Order', 'Source Country', 'Education Level', 'Degree', 'Status']
    },
    {
        text: 'Course Type',
        id: "1",
        key_value_columns: ['Option Name', 'Option Value', 'Sort Order', 'Source Country', 'Destination Country']
    },
    {
        text: 'Education Level',
        id: "1721987602",
        key_value_columns: ['Option Name', 'Option Value', 'Sort Order', 'Source Country', 'Highest Qualification', 'Course Type', 'Status']
    },
    {
        text: 'Course Compare',
        id: "1724999172",
        key_value_columns: ['Course Option', 'Option Name', 'Source Country']
    },
    {
        text: 'Intake',
        id: "13",
        key_value_columns: ['Option Name', 'Option Value', 'Sort Order', 'Destination Country', 'Status']
    },
    {
        text: 'Automation Files',
        id: "1727069125",
        key_value_columns: ['Option Name', 'Option Value', 'Sort Order', 'Source Country', 'University']
    },
    {
        text: 'Advance Filters',
        id: "17271825786633",
        key_value_columns: ['Option Name', 'Option Value', 'Sort Order', 'Source Country', 'Destination Country']
    },
    {
        text: 'Subject',
        id: "17399635071655",
        key_value_columns: ['Option Name', 'Option Value', 'Sort Order', 'Country', 'University']
    },
    {
        text: 'Campus',
        id: "16",
        key_value_columns: ['Option Name', 'Option Value', 'Sort Order', 'Country', 'University']
    }
]

export const EmailRegex = /^\S+@\S+\.\S+$/;